import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import { WebService } from "../../Services/WebService";
import { useDispatch, useSelector } from "react-redux";
import { ActionPermission, PageInfo } from "../PageInfo";
import SnackbarComponent from "../../Services/SnackbarComponent";
import DeleteConfirmAlert from "../../Services/AlertComponent";
import ActionButton from "../../Services/ActionButton";
import StaticListComponent from "../../Services/StaticListComponent";
import TableComponent, { NoRecordTemplate } from "../../Services/TableComponent";
import Button from "react-bootstrap/esm/Button";
import { StandardConst } from "../../Services/StandardConst";
import { statusUpdate as ConfigurationflowStatusUpdate } from "../../Services/ConfigurationFlow";
import { Box, Container, Typography, Stack } from "@mui/material";
import { Form, FormInputDropdown, FormInputText, InputDropdown } from '../Form'
import BreadcrumbsComponent from "../../Services/BreadcrumbsComponent";
import Modal from "react-bootstrap/Modal";
import * as yup from "yup";
import { WSErrorAlert, WSSuccessAlert, WSWarningAlert } from "../../Services/WSAlert";
const _ = require("underscore");

const EmployeeCustomFields = () => {

    const MasterPageName = "Manage Employee Custom Fields";
    const confirmMessage = MasterPageName + " Deleted successfully";
    const AddButtonText = "New Field";
    const ref = useRef();
    const refSnackbar = useRef();
    PageInfo({ pageTitle: "Manage Employee Custom Fields" });
    const dispatch = useDispatch();
    const [customFieldsData, setCustomFieldsData] = useState([]);
    const [countriesDropdown, setCountriesDropdown] = useState([{ value: 0, text: "All Countries" }]);
    const [companiesDropdown, setCompaniesDropdown] = useState([]);

    const [selectedCompanyId, setSelectedCompanyId] = useState(null);
    const [selectedCountryId, setSelectedCountryId] = useState(null);
    const Roles = useSelector((s) => s.auth.AssignRole ?? {});
    const isSuperAdmin = Roles?.some(element => element === StandardConst.SystemRole.SuperAdmin);
    const [permission, SetPermission] = useState({});
    const permissionList = useSelector((s) => s.auth.PermissionList ?? []);
    const companyInfo = useSelector((s) => s.auth.CompanyInfo ?? {});
    const addEditModalRef = useRef();
    const assignedRole = useSelector((s) => s.auth.AssignRole ?? []);

    useEffect(() => {
        SetPermission({
            ManageAdd: ActionPermission("Employee Custom Field - Add"),
            ManageEdit: ActionPermission("Employee Custom Field - Edit"),
            ManageDelete: ActionPermission("Employee Custom Field - Delete"),
        });
    }, [permissionList]);

    const [bData] = React.useState([
        {
            title: "Employee Management",
            hrefLink: "#",
        },
        {
            title: "Manage Employee Custom Fields",
            hrefLink: "#",
        },
    ]);

    const fetchEmployeeCustomFields = async () => {
        const data = await WebService({
            endPoint: `UserProfile/fetchEmployeeCustomFields?CountryId=${companyInfo.CountryId}`,
            dispatch,
        });
        setCustomFieldsData(data.sort((a, b) => a.DisplayOrder - b.DisplayOrder));
        dispatch(ConfigurationflowStatusUpdate());
    };

    const [deletedEmployeeCustomFieldLabel, setDeletedEmployeeCustomFieldLabel] = useState(null);
    const onDelete = async (EmployeeCustomFieldDetail) => {
        const EmployeeCustomFieldData = EmployeeCustomFieldDetail.split(',');
        const EmployeeCustomFieldId = EmployeeCustomFieldData[0];
        const EmployeeCustomFieldLabel = EmployeeCustomFieldData[1];
        setDeletedEmployeeCustomFieldLabel(EmployeeCustomFieldLabel);

        await WebService({
            endPoint: `CommonUtility/employeecustomfields?EmployeeCustomFieldId=${EmployeeCustomFieldId}`,
            method: "DELETE",
            dispatch,
        });
        refSnackbar.current.setOpenSnackBar();
        await fetchEmployeeCustomFields();
    };




    const fetchAllCountries = async () => {
        await WebService({
            endPoint: `CommonUtility/fetchAll/countries`,
            dispatch,
        }).then((res) => {
            if(res.length > 0){
                setCountriesDropdown([{ value: 0, text: "All Countries" }, ...res.map(item => ({value: item.CountryId, text: item.Country}))]);
            }
        })
    }

    const fetchAllCompanies = async () => {
        await WebService({
            endPoint: `CommonUtility/fetchAll/companyinformation?CompanyId=${StandardConst.YesNo.Yes}`,
            dispatch,
        }).then((res) => {
            if(res.length > 0){
                var CompaniesList = res.map(item => ({value: item.CompanyId, text: item.CompanyName}));
                
                const supperAdminRole = assignedRole.some(item => item === StandardConst.SystemRole.SuperAdmin);
                if(supperAdminRole){
                    CompaniesList = [{ value: 0, text: "All Companies" }, ...CompaniesList];
                }
                setCompaniesDropdown(CompaniesList);
            }
        })
    }

    useEffect(() => {
        Promise.all([
            fetchAllCountries(),
            fetchAllCompanies()
        ])
    }, [assignedRole]);

    useEffect(() => {
        fetchEmployeeCustomFields();
    }, [selectedCompanyId, selectedCountryId]);

    const fnEdit = async (id) => await addEditModalRef.current.openModal(id || 0);


    const handleFieldsOrdring = async (clickedObj, clickedArrow) => {

        // const customFieldsData = filter(invoiceSettingState?.Details, {
        //   Section: clickedObj.Section,
        // })?.sort((a, b) => a.DisplayOrder - b.DisplayOrder);
    
        const maxOrderNumber = customFieldsData[customFieldsData.length - 1].DisplayOrder;
    
        const minOrderNumber = customFieldsData[0].DisplayOrder;
    
        const checkOrder = clickedArrow == StandardConst.ArrowClicked.Up ? clickedObj.DisplayOrder - 1 : clickedObj.DisplayOrder + 1 ;

        if(checkOrder >= minOrderNumber && checkOrder <= maxOrderNumber){
          const clickedRowIndex = customFieldsData.findIndex(item => 
            item.EmployeeCustomFieldId === clickedObj.EmployeeCustomFieldId);
    
          const nextUpdateIndex = clickedArrow == StandardConst.ArrowClicked.Up ? clickedRowIndex - 1 : clickedRowIndex + 1;
          const nextUpdateEmployeeCustomFieldId = customFieldsData[nextUpdateIndex].EmployeeCustomFieldId;
          const nextUpdatedOrderNumber = customFieldsData[nextUpdateIndex].DisplayOrder;
    
          await WebService({
            dispatch,
            endPoint: `UserProfile/UpdateOrdringInEmployeeColumnFields`,
            method: "PUT",
            body: {
              ClickedUpdatedEmployeeCustomFieldId: clickedObj.EmployeeCustomFieldId, 
              ClickedUpdatedOrderNumber: clickedObj.DisplayOrder, 
              NextUpdatedEmployeeCustomFieldId: nextUpdateEmployeeCustomFieldId, 
              NextUpdatedOrderNumber: nextUpdatedOrderNumber, 
            }
            // body: clickedObj
          }).then((response) => {
            if(response > 0){
                fetchEmployeeCustomFields();
            }
          });
        }
    };

    const columns = [
        {
            Text: "Field Label",
            Value: "FieldLabel",
        },
        {
            Text: "Field Name",
            Value: "FieldName",
        },
        {
            Text: "Field Type",
            Value: "FieldType"
        },
        {
            Text: "Field Required",
            render: (dr) => <span>{StandardConst.YesOrNo?.find(element => element?.value === dr.FieldIsRequired).text}</span>
        },
        {
            Text: "Action",
            cssClass: "text-center td-width-100",
            isVisiable: (permission.ManageEdit || permission.ManageDelete ) ,
            render: (dr) =>   (isSuperAdmin || dr.CompanyId) &&  (
                <>
                    <ActionButton
                        onClick={() => fnEdit(dr.EmployeeCustomFieldId)}
                        disabled={!permission.ManageEdit}
                        IconName="Edit"
                        IconTooltip={"Edit Custom Field"}
                        id={`btnCustomFieldEdit_${dr.EmployeeCustomFieldId}`}
                    />
                    <ActionButton
                        onClick={(e) =>
                            ref.current.confirmAlert(
                                "Permanent Delete", //Confirm button text
                                "CRITICAL! Permanent Delete ", // Text if Alert
                                `All Employees data entered in "${dr.FieldLabel}" field will be permanently deleted. Do you want to delete ?`, // Message of Alert
                                `${dr.EmployeeCustomFieldId},${dr.FieldLabel}` // Endpoint to hit for delete
                            )}
                        disabled={!permission.ManageDelete}
                        IconName="Delete"
                        IconTooltip={"Delete custom field"}
                        id={`btnCustomFieldDelete_${dr.EmployeeCustomFieldId}`}
                    />

                    <ActionButton
                        onClick={() => handleFieldsOrdring(dr, StandardConst.ArrowClicked.Up)}
                        // disabled={!permission.ManageEdit}
                        IconName="UpArrow"
                        IconTooltip={"Up Arrow"}
                        id={`UpArrow${dr.EmployeeCustomFieldId}`}
                    />

                    <ActionButton
                        onClick={() => handleFieldsOrdring(dr, StandardConst.ArrowClicked.Down)}
                        // disabled={!permission.ManageEdit}
                        IconName="DownArrow"
                        IconTooltip={"Down Arrow"}
                        id={`DownArrow${dr.EmployeeCustomFieldId}`}
                    />
                </>
            ),
        },
    ]

    return (
        <>
            <div className="base-container">
                <Box
                    sx={{
                        pt:1,
                        width: 1,
                    }}
                >
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="">
                            <h5 className="ms-4 mt-2">{MasterPageName}</h5>
                            <div className="ms-4">
                                <BreadcrumbsComponent bData={bData}></BreadcrumbsComponent>
                            </div>
                        </div>
                    </div>
                </Box>
                <SnackbarComponent ref={refSnackbar} confirmMessage={`Custom Field ${(deletedEmployeeCustomFieldLabel!== null) ? deletedEmployeeCustomFieldLabel : ""} Deleted successfully`} />
                <DeleteConfirmAlert    ref={ref}  confirmEvent={(v) => onDelete(v)} />
                <div className="row">
                    <div className="col-md-3 col-sm-12" style={{marginLeft: "23px"}}>
                        <InputDropdown
                            name="CompanyId"
                            ddOpt={companiesDropdown}
                            isRequired="true"
                            label="Companies"
                            setValue={(currentValue) => setSelectedCompanyId(parseInt(currentValue))}
                        ></InputDropdown>
                    </div>
                    <div className="col-md-3 col-sm-12" style={{marginLeft: "23px"}}>
                        <InputDropdown
                            name="CountryId"
                            ddOpt={countriesDropdown}
                            isRequired="true"
                            label="Countries"
                            setValue={(currentValue) => setSelectedCountryId(parseInt(currentValue))}
                        ></InputDropdown>
                    </div>
                </div>
                <TableComponent
                    columns={columns}
                    noRecordCss="p-0"
                    noRecordFound={
                        <NoRecordTemplate
                            headerValue={StandardConst.EmployeeCustomFieldheaderValueNoResults}
                            subHeaderValue={StandardConst.EmployeeCustomFieldSubHeader}
                            imageUrl={StandardConst.imageNoRecordsFound}
                            actionButton={
                                <>
                                    {permission.ManageAdd && (
                                        <Button variant="outline-primary" onClick={() => fnEdit(0)} id={`no_record_add_${AddButtonText}`}>
                                            Add {AddButtonText}
                                        </Button>
                                    )}
                                </>
                            }
                        />
                    }
                    data={customFieldsData}
                    isSearchRequired={true}
                    title={AddButtonText}
                    onAddEvent={() => fnEdit()}
                    IsAddButtonVisible={permission?.ManageAdd}
                    allowSerialNo={true}
                />
                <AddEditEmployeeCustomField
                    callBackEvent={async () => await fetchEmployeeCustomFields()}
                    ref={addEditModalRef}
                    countriesDropdown = {countriesDropdown}
                    companiesDropdown = {companiesDropdown}
                ></AddEditEmployeeCustomField>
            </div>
        </>
    );
}

const AddEditEmployeeCustomField = forwardRef((props, ref) => {

    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const [data, setData] = useState({});
    const [countriesDropdown, setCountriesDropdown] = useState(props.countriesDropdown);
    const [companiesDropdown, setCompaniesDropdown] = useState(props.companiesDropdown);
  const CompanyInfo = useSelector((s) => s.auth.CompanyInfo ?? {});

    useEffect(() => {
        setCountriesDropdown(props.countriesDropdown);
        setCompaniesDropdown(props.companiesDropdown);
    }, [props]);

    useImperativeHandle(ref, () => ({
        openModal: async (id) => {
            if (id > 0) {
                await fetchEditValue(id);
            }
            setShow(true);
        },
    }));

    const fetchEditValue = async (id) => {
        const data = await WebService({
                endPoint: `CommonUtility/Edit/employeecustomfields?EmployeeCustomFieldId=${id || 0}`,
                dispatch,
            }).then((c) => (c.length > 0 ? c[0] : {}));

        setData(data);
    }

    const handleClose = () => {
        setShow(false);
        setData({});
    }
    const schema = yup
        .object()
        .shape({
            FieldName: yup.string().trim().required(StandardConst.ValidationMessages.RequiredFieldMsg),
            FieldLabel: yup.string().trim().required(StandardConst.ValidationMessages.RequiredFieldMsg),
            FieldType: yup.string().trim().required(StandardConst.ValidationMessages.RequiredFieldMsg),
        })
        .required();

    const onSubmit = async (data) => {
        handleClose();
        if(parseInt(data.CompanyId) === StandardConst.YesNo.No){
            data.CompanyId = null;
        }
        if(parseInt(data.CountryId) === StandardConst.YesNo.No){
            data.CountryId = null;
        }
        // this api is bringing count of existing entries with same name
        const IsDuplicateQuery= await WebService({
            endPoint:'UserProfile/CheckDuplicateCustomField',
            method:'post',
            body:{"CountryId":CompanyInfo.CountryId,"FieldName":data.FieldName}

        })

        if (IsDuplicateQuery.count >= 1) {
            WSErrorAlert("Error",`Custom Field With Name "${data.FieldName}" Already Exist!`);
            return; // Exit the function if a duplicate is found
        }

        if (data.EmployeeCustomFieldId === undefined) {
            const existingData = await WebService({
                endPoint: `UserProfile/fetchEmployeeByCompanyAndCountry?CompanyId=${(data.CompanyId === null || data.CompanyId === StandardConst.YesNo.No) ? 'IS NULL' : data.CompanyId}&CountryId=${(data.CountryId === null || data.CountryId === StandardConst.YesNo.No) ? 'IS NULL' : data.CountryId}`,
                dispatch,
            });
            let maxDisplayOrder = 0;

            if(existingData.length > 0){
                maxDisplayOrder = _.max(existingData, item => item.DisplayOrder).DisplayOrder;
            }
            data.DisplayOrder = (parseInt(maxDisplayOrder) + 1);
            await WebService({
                endPoint: "CommonUtility/Insert/employeecustomfields",
                body: data,
                method: "POST",
                dispatch,
            }).then(res => {
                WSSuccessAlert("Success", `${data.FieldName} added successfully`)
            });
        } else {
            await WebService({
                endPoint: `CommonUtility/employeecustomfields?EmployeeCustomFieldId=${data.EmployeeCustomFieldId}`,
                method: "PUT",
                body: data,
                dispatch,
            }).then(res => {
                WSSuccessAlert("Success", `${data.FieldName} updated successfully`)
            });
        }
        props.callBackEvent();
    };


    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {(data?.EmployeeCustomFieldId || 0) === 0
                        ? "Add Employee Custom Field"
                        : "Edit Employee Custom Field"}
                </Modal.Title>
            </Modal.Header>
            <Form
                defaultValues={data}
                onSubmit={onSubmit}
                validationSchema={schema}
            >
                <Modal.Body className="p-4">
                    <div className="row">
                        <div className="col-md-12 pb-1">
                            <FormInputDropdown
                                label="Companies"
                                name="CompanyId"
                                ddOpt={companiesDropdown}
                                isRequired="true"
                            />
                        </div>
                        <div className="col-md-12 pb-1">
                            <FormInputDropdown
                                label="Countries"
                                name="CountryId"
                                ddOpt={countriesDropdown}
                                isRequired="true"
                            />
                        </div>
                        <div className="col-md-12">
                            <FormInputText
                                label="Field Label"
                                name="FieldLabel"
                                type="text"
                                isRequired="true"
                            />
                        </div>
                        <div className="col-md-12">
                            <FormInputText
                                label="Field Name"
                                name="FieldName"
                                type="text"
                                isRequired="true"
                            />
                        </div>
                        <div className="col-md-12 pb-1">
                            <FormInputDropdown
                                label="Field Type"
                                name="FieldType"
                                ddOpt={StandardConst.invoiceFieldType}
                                isRequired="true"
                            />
                        </div>
                        <div className="col-md-12 pb-2">
                            <FormInputDropdown
                                name="FieldIsRequired"
                                ddOpt={StandardConst.YesOrNo}
                                label="Field Is Required"
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        id="btnEmployeeCustomFieldSubmit"
                        variant="outline-primary"
                        type="submit"
                    >
                        {" "}
                        {(data?.EmployeeCustomFieldId || 0) === 0
                            ? "Submit"
                            : "Save Changes"}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
});

export default EmployeeCustomFields;